import React, { useMemo } from 'react'
import { PageSettings } from '@http/api-models/page-settings'
import { Container } from '@shared/components/container'
import PageAnimation from '@shared/components/page-animation'

import { useNodeParamsGetterCreator } from '../../hooks/useNodeParams'
import { AvailableComponentTypes, PageNode, PageNodeViewModel } from '../../types'
import { getRangeArr } from '../../utils'

import { AdminPageNode } from './node'
import { SEO } from './SEO'

import styles from './style.module.scss'

export const AdminRootPage = ({ admin }: PageSettings) => {
	const nodeParamsGetter = useNodeParamsGetterCreator()
	const sortedNodes = useMemo(
		() => [...(admin?.page?.pageNode ?? [])].sort((a, b) => a.order - b.order),
		[admin?.page?.pageNode]
	)

	const nodeViewModels = useMemo(() => {
		const arr: PageNodeViewModel[] = []
		for (let cursor = 0; cursor < sortedNodes.length; cursor++) {
			const node = sortedNodes[cursor]
			if (['tabs', 'faq'].every((name) => name !== node.name)) {
				arr.push({ value: node })
				continue
			}

			const getter = nodeParamsGetter.createGetter(node.nodeParam)
			const tabsLen = getter(AvailableComponentTypes.stringArray, '').split('\n').length
			const range = getRangeArr(cursor, cursor + tabsLen).slice(1)
			const childs = range.map((i) => sortedNodes[i])
			arr.push({
				value: node,
				children: childs
					.map((child) => {
						if (child) {
							return {
								value: child,
							}
						}

						return null
					})
					.filter(Boolean) as PageNodeViewModel[],
			})
			cursor = range[range.length - 1]
		}

		return arr
	}, [sortedNodes])

	return (
		<PageAnimation>
			<SEO />
			{nodeViewModels.map((node) => {
				if (node.value?.isWrappedContainer) {
					return (
						<Container key={node.value.id} className={styles.wrapper}>
							<AdminPageNode nodeViewModel={node} />
						</Container>
					)
				}
				return <AdminPageNode key={node.value.id} nodeViewModel={node} />
			})}
		</PageAnimation>
	)
}
